module.exports = __webpack_public_path__ + "img/explain-icon.48605790.gif";